/* eslint-disable */
function searchEntities(collection, options, next) {
  let { is_branded, kind, limit, name, query, status, taxonomy } = options

  // escape possible regex eg. +
  let parsed_query = query && query.replace('+', '\\+')

  window._api.get(
    `/${collection}/search`,
    {
      is_branded,
      kind,
      limit,
      name,
      q: parsed_query,
      status,
      taxonomy,
    },
    (error, entities) => {
      if (error) {
        toast.error(error.message)
      } else {
        // add kind after name
        if (collection == 'topics') {
          entities.forEach((topic) => {
            topic.orig_name = topic.name
            if (topic.kind != 'Topic') {
              topic.name += ` (${topic.kind})`
            }
          })

          // filter returned audiences
        } else if (collection == 'audiences') {
          entities = entities.map((audience) => {
            return {
              _id: audience._id,
              name: audience.name,
              updated_at: audience.updated_at,
            }
          })
        }

        next(entities)
      }
    }
  )
}

module.exports = searchEntities
/* eslint-enable */
